
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { FileText, Shield, ScrollText } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const LegalLinksGrid = () => {
  const navigate = useNavigate();

  return (
    <div className="grid gap-6 md:grid-cols-3">
      <Card className="hover:shadow-md transition-shadow cursor-pointer" onClick={() => navigate("/privacy")}>
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-base">
            <Shield className="h-5 w-5 text-primary flex-shrink-0" />
            Privacy Policy
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-gray-600">
            View our privacy policy and data protection guidelines
          </p>
        </CardContent>
      </Card>

      <Card className="hover:shadow-md transition-shadow cursor-pointer" onClick={() => navigate("/legal-information")}>
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-base">
            <FileText className="h-5 w-5 text-primary flex-shrink-0" />
            Legal Information
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-gray-600">
            Access important legal documents and information
          </p>
        </CardContent>
      </Card>

      <Card className="hover:shadow-md transition-shadow cursor-pointer" onClick={() => navigate("/terms")}>
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-base">
            <ScrollText className="h-5 w-5 text-primary flex-shrink-0" />
            Terms & Acknowledgments
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-gray-600">
            Review our terms of service and acknowledgments
          </p>
        </CardContent>
      </Card>
    </div>
  );
};
